<p-dialog appendTo="body" [(visible)]="visible" (onHide)="hide()" [modal]="true" [style]="{'width': '650px', 'height': '250px'}">

  <p-header>
    <span>{{dialogLabel}}</span>
  </p-header>

  <div style="overflow-x: hidden;">
    <form [formGroup]="settingsForm">

      <div class="mb-3 row">
        <span class="col-lg-2">IP Address:</span>
        <div class="col-lg-6">
          <select class="form-control" [formControl]="ipAddress" >
            @for (value of ipAddressOptions; track value) {
              <option [ngValue]="value">{{value}}</option>
            }
          </select>
        </div>
        <div class="col-lg-4">
          <input type="checkbox" [formControl]="showIpV6Addresses" (change)="onShowIpV6Changed()" />
          <span class="uv-checkbox-label">Show IPv6 Addresses</span>
        </div>
      </div>

      <div class="mb-3 row">
        <span class="col-lg-2">Hostname:</span>
        <div class="col-lg-6">
          <input class="form-control" type="text" [formControl]="hostname" />
        </div>
        <div class="col-lg-4">
          <input type="checkbox" [formControl]="pingHostname" />
          <span class="uv-checkbox-label">Ping Hostname</span>
        </div>
      </div>

    </form>
  </div>

  <p-footer>
    <button type="button" pButton icon="fa fa-check" [disabled]="!isSaveEnabled()" (click)="onSaveClicked()" label="Save"></button>
    <button type="button" pButton icon="fa fa-close" (click)="onCancelClicked()" label="Cancel"></button>
  </p-footer>

</p-dialog>
